import { Box } from "@mui/material";
import SuccessCaseB3 from "../components/SuccessCaseB3";
import CasesCards from "./CasesCards";
import CasesClosing from "./CasesClosing";

export default function Cases() {
    return (
        <Box component="main" sx={{ bgcolor: "#0f1011" }}>
            <SuccessCaseB3 />
            <CasesCards />
            <CasesClosing />
        </Box>
    );
}